import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { map, Observable } from 'rxjs';
import moment from 'moment';

import { Task } from 'src/app/models/task/task';
import { CalendarStaff } from 'src/app/models/calendar/calendar-staff';
import { Role } from 'src/app/models/role/role';
import { HttpService } from 'src/app/services/http/http.service';
import { TypeStaffTask } from 'src/app/enumerates/type-staff-task';
import { ScheduleServiceFull } from '@schedule/models/schedule/schedule-service-full';
import { EndpointParams } from '@models/http/endpoint-params';
import { ScheduleServiceDelete } from '@schedule/models/schedule/schedule-service-delete';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 2 };

    private selectedDate: Date = new Date();

    setNewDate(selectedDate: Date): void {
        this.selectedDate = selectedDate;
    }

    getTasks(): Observable<Task[]> {
        const url = 'employee/calendar/me';
        const params = this.buildGetParams(new HttpParams({ fromString: this.dateToString() }));

        return this.get(url, { app: 'center', version: 3 }, params);
    }

    getCalendarActivities(): Observable<CalendarStaff> {
        const url = 'calendar/app/staff';
        const params = this.buildGetParams(new HttpParams({ fromString: this.dateToString() }));

        return this.get(url, {app: 'booking', version: 2}, params);
    }

    dateToString(): string {
        return `startDateTime=${moment(this.selectedDate).format('YYYY-MM-DD')}&endDateTime=${moment(this.selectedDate).format('YYYY-MM-DD')}`;
    }

    getRoles(): Observable<Role[]> {
        const url = 'roles';

        return this.get(url, { app: 'center', version: 1 });
    }

    getServiceData(id: number): Observable<any> {
        return this.get(`services/${id}`, { app: 'center', version: 1 });
    }

    getTaskData(id: number): Observable<any> {
        return this.get(`tasks/${id}`, { app: 'center', version: 1 });
    }

    getScheduleService(id: string, type: TypeStaffTask): Observable<ScheduleServiceFull> {
        const url = `employee/scheduleservices/${id}?type=${type}`;

        return this.get(url, this.defaultEndpointParams).pipe(map(res => new ScheduleServiceFull().build(res)));
    }

    deleteScheduleService(scheduleServiceDelete: ScheduleServiceDelete, message: string): Observable<void> {
        const url = `employee/scheduleservices/${scheduleServiceDelete.id}?type=${scheduleServiceDelete.type}`;
        const body = {
            ...this.showSuccessMessage(message),
            body: scheduleServiceDelete
        };

        return this.delete(url, this.defaultEndpointParams, body);
    }

    validateScheduleService(id: string, type: TypeStaffTask, message: string): Observable<void> {
        const url = `employee/scheduleservices/${id}/validate?type=${type}`;

        return this.post(url, this.defaultEndpointParams, null, this.showSuccessMessage(message));
    }
}
